import { useNavigate } from "react-router-dom";
import Button from "../../Components/Buttons/Button";
import Text from "../../Components/Text";
import RoleGuard from "../../Components/RoleGuard";
import TIcon from "../../Components/TIcon";
import ScrollWrapper from "../../Components/ScrollWrapper";

const IndexPage = ({ title = "", items = [], headItems = [], iconSize = 60, buttonWrapping = "", headMobile = false, additionalContent = null }) => {
    const navigate = useNavigate();

    const buttonAction = (path, action) => {
        if (action) {
            action()
        } else {
            if (path) {
                navigate(`/app${path}`)
            }
        }
    }

    const customButtonElement = (text, description, customText, tIcon, iconColor, iconBackground, path, action, backgroundColor) => (
        <Button classNames={`w-full ${buttonWrapping}`}
            buttonColor={backgroundColor || "bg-white"}
            disabled={!(action || path)}
            borderStyle={`rounded-xl p-5 border border-[#FCFCFB] ${action || path ? 'hover:border-[#a4a5a6]' : ''}`}
            onClickAction={(e) => buttonAction(path, action)}>
            <div className="flex flex-col w-full gap-2">
                {tIcon && (
                    <div className={`flex items-center justify-center w-20 h-20 ${iconBackground ? iconBackground : "bg-gray-300"} rounded-md`}>
                        <TIcon name={tIcon} size={iconSize} color={iconColor} />
                    </div>
                )}

                {customText && customText.map((customTextItem, index) => (
                    customTextItem.icon ? (
                        <div key={index} className="flex w-full text-start justify-between">
                            <Text type={customTextItem.type || "main"} classNames={customTextItem.classNames}>
                                {customTextItem.text}
                            </Text>
                            <TIcon name={customTextItem.icon} size={customTextItem.iconSize || 20} color={customTextItem.iconColor} />
                        </div>
                    ) : (
                        <div key={index} className="flex w-full text-start">
                            <Text type={customTextItem.type || "main"} classNames={customTextItem.classNames}>
                                {customTextItem.text}
                            </Text>
                        </div>
                    )
                ))}

                {text && (
                    <div className="flex w-full text-start">
                        <Text type="main">{text}</Text>
                    </div>
                )}

                {description && (
                    <div className="flex w-full text-start">
                        <Text type="subtitle">{description}</Text>
                    </div>
                )}
            </div>
        </Button>
    )

    const itemElement = (text, description, customText, tIcon, iconColor, iconBackground, path, action, hidden, role, backgroundColor) => (
        hidden ? null : role ? (
            <RoleGuard specificRole={role}>
                {customButtonElement(text, description, customText, tIcon, iconColor, iconBackground, path, action, backgroundColor)}
            </RoleGuard>
        ) : customButtonElement(text, description, customText, tIcon, iconColor, iconBackground, path, action, backgroundColor)
    )

    return (
        <div className="bg-gray-100 border-black flex flex-col w-full h-full p-3 pr-0 overflow-hidden">
            <Text type="maintitle">{title}</Text>
            <ScrollWrapper>
                <div className={`${headMobile ? "flex" : "hidden md:flex md:grid md:grid-cols-3"} w-full h-min flex-col gap-3 pt-3 pl-3 pr-3`}>
                    {headItems.map((item, index) => (
                        <div key={index} className="mb-0">
                            {itemElement(
                                item.text,
                                item.description,
                                item.customText,
                                item.icon,
                                item.iconColor,
                                item.iconBackground,
                                item.path,
                                item.action,
                                item.hidden,
                                item.role,
                                item.backgroundColor
                            )}
                        </div>
                    ))}
                </div>
                <div className="w-full h-min flex flex-col md:grid md:grid-cols-2 gap-3 pt-3 pl-3 pr-3">
                    {items.filter(Boolean).map((item, index) => (
                        <div key={index} className="mb-2 md:mb-0">
                            {itemElement(
                                item.text,
                                item.description,
                                item.customText,
                                item.icon,
                                item.iconColor,
                                item.iconBackground,
                                item.path,
                                item.action,
                                item.hidden,
                                item.role,
                                item.backgroundColor
                            )}
                        </div>
                    ))}
                </div>
                {additionalContent && (
                    <div className="w-full flex flex-col gap-3 pt-3 pl-3 pr-3">
                        {additionalContent}
                    </div>
                )}
            </ScrollWrapper>
        </div>
    )
}
export default IndexPage